import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryCouponExpired extends MonthlySummaryError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('The promotional coupon is expired', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default MonthlySummaryCouponExpired;
